// Corresponds to values sent in graphQLErrors[x].message
export const GRAPHQL_ERROR_MESSAGES = {
  INVALID_SHARE_PASSPHRASE: 'invalid share passphrase',
  INVALID_SHARE: 'invalid share',
  UNAUTHENTICATED: 'unauthenticated',
  UNCONFIRMED_EMAIL: 'Email must be confirmed',
  INVALID_UPLOAD_LINK_PASSPHRASE: 'invalid passphrase',
  INVALID_UPLOAD_LINK: 'invalid upload link',
};

// Corresponds to values sent in graphQLErrors[x].extensions.code
// Codes can have multiple corresponding messages
// https://github.com/Frameio/massdriver/blob/qa/apps/api/lib/api/web/graphql/errors.ex
export const GRAPHQL_ERROR_CODES = {
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  PERMISSION_DENIED: 'PERMISSION_DENIED', // Not authorized
  FAILED_PRECONDITION: 'FAILED_PRECONDITION',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
} as const;
